module.exports = __webpack_public_path__ + "assets/img/wh5_p08.e5e9fd1e.png";